const topbar = {
    docs: 'Documentazione',
    help: 'Aiuto',
};
export default Object.freeze(topbar);
